<template>
  <div
    class="row items-start"
    :class="{ 'editor-highlighted': section.isTranslation }"
    data-test-id="rich-section-editor"
    @keydown.stop
  >
    <q-editor
      v-model="section.content"
      class="custom-section"
      :dense="$q.screen.lt.md"
      :definitions="{
        insert_img: {
          tip: 'Insert Image',
          icon: 'photo',
          handler: insertImage,
          disable: insertImageIsDisabled
        }
      }"
      :toolbar="[
        [
          {
            label: $q.lang.editor.align,
            icon: $q.iconSet.editor.align,
            fixedLabel: true,
            list: 'only-icons',
            options: ['left', 'center', 'right', 'justify']
          }
        ],
        ['insert_img'],
        ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
        ['token', 'hr', 'link', 'custom_btn'],
        ['print', 'fullscreen'],
        [
          {
            label: $q.lang.editor.formatting,
            icon: $q.iconSet.editor.formatting,
            list: 'no-icons',
            options: [
              'p',
              'h1',
              'h2',
              'h3',
              'h4',
              'h5',
              'h6',
              'code'
            ]
          },
          {
            label: $q.lang.editor.fontSize,
            icon: $q.iconSet.editor.fontSize,
            fixedLabel: true,
            fixedIcon: true,
            list: 'no-icons',
            options: [
              'size-1',
              'size-2',
              'size-3',
              'size-4',
              'size-5',
              'size-6',
              'size-7'
            ]
          },
          {
            label: $q.lang.editor.defaultFont,
            icon: $q.iconSet.editor.font,
            fixedIcon: true,
            list: 'no-icons',
            options: [
              'default_font',
              'arial',
              'arial_black',
              'comic_sans',
              'courier_new',
              'impact',
              'lucida_grande',
              'times_new_roman',
              'verdana'
            ]
          },
          'removeFormat'
        ],
        ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

        ['undo', 'redo'],
        ['viewsource']
      ]"
      :fonts="{
        arial: 'Arial',
        arial_black: 'Arial Black',
        comic_sans: 'Comic Sans MS',
        courier_new: 'Courier New',
        impact: 'Impact',
        lucida_grande: 'Lucida Grande',
        times_new_roman: 'Times New Roman',
        verdana: 'Verdana'
      }"
    />
  </div>
</template>

<script>

import { imgixHost } from 'src/config'
import Section from 'src/models/page/Section'

export default {
  name: 'RichSectionEditor',
  components: {
  },
  props: {
    section: {
      type: Section,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    insertImage () {
      const selectedNode = window.getSelection().baseNode
      if (selectedNode.parentNode.closest('.q-editor__content') || selectedNode.closest('.q-editor__content')) {
        // create an input file element to open file dialog
        const input = document.createElement('input')
        input.type = 'file'
        input.accept = 'image/*'
        input.onchange = async _ => {
          const imageLoading = document.createElement('div')
          imageLoading.textContent = 'Image Loading...'
          selectedNode.append(imageLoading)
          const files = Array.from(input.files)
          const file = files[0]
          const { key } = await this.$directUpload.uploadFile(file, true)
          const imageElement = document.createElement('img')
          imageElement.src = imgixHost + '/' + key + '?max-w=1000&fit=fill&auto=format'
          imageElement.style = 'max-width: 100%;'
          selectedNode.append(imageElement)
          imageLoading.remove()
          const content = selectedNode.parentNode.closest('.q-editor__content') || selectedNode.closest('.q-editor__content')
          this.section.content = content.innerHTML.toString()
        }
        input.click()
      }
    },
    insertImageIsDisabled () {
      const selectedNode = window.getSelection().baseNode
      return typeof selectedNode?.append !== 'function'
    }
  }
}
</script>

<style lang="scss" scoped>
.editor-highlighted {
  outline: 3px solid $amber-6;
}
</style>
